"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userTeamData = exports.managedTeamData = void 0;
exports.managedTeamData = {
    result: {
        name: 'Team1',
        users: [
            { status: 'accepted', email: 'user@test.com' },
            { status: 'accepted', email: 'user2@test.com' },
        ],
    },
    error: null,
};
exports.userTeamData = { result: { team_name: 'Bananas', is_manager: true } };
